import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig, CustomerProductPurchaseSearchDateRange } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient, WebTrackUser, GetProductPurchasesRequest, CustomerProductPurchaseSearchParameters } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { PagingParameters, SortParameters, SortParametersDirection, Branch } from 'ep-bt-field-agent-proxy';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-products-purchased-grid',
  templateUrl: './epbt-fa-customer-products-purchased-grid.component.html',
  styleUrls: ['./epbt-fa-customer-products-purchased-grid.component.scss']
})
export class EpbtFaCustomerProductsPurchasedGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;


  private _customerId;
  products: any;
  @Input() customerId: number;

  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
    // this.filterService.purchasedProductSearch = this._searchString;
  }

  get searchString(): string { return this._searchString; }

  @ViewChild('emailTemplate', { static: false }) emailTemplate: TemplateRef<any>;
  @ViewChild('dateTemplate', { static: true }) dateTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: true }) statusTemplate: TemplateRef<any>;
  @ViewChild('quantityTemplate', { static: true }) quantityTemplate: TemplateRef<any>;
  @ViewChild('sellPriceTemplate', { static: true }) sellPriceTemplate: TemplateRef<any>;
  @ViewChild('totalPriceTemplate', { static: true }) totalPriceTemplate: TemplateRef<any>;
  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 50;
  public cards: Array<IEpBtCardControlModel>;


  startdate: any;
  webTrackUser: any;
  customerProductRequest: GetProductPurchasesRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;
  currency: string;
  bisTrackSettings: any;

  @Output() loadingChange = new EventEmitter<boolean>();
  purchasedProductsCollection: any = [];
  totalPages = 1;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService, private config: BistrackConfig,
    private sortService: EpbtFaSortService, private filterService: EpbtFaFilterService) { }

  ngOnInit() {
    // this.bisTrackSettings = this.fieldAgentService.getBisTrackSetting();
    // this.currency = this.bisTrackSettings.baseCurrency.symbol;
    // this.pageSize = this.bisTrackSettings.searchPageSize;

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bisTrackSettings = bistrackSettings;
      this.currency = this.bisTrackSettings.baseCurrency.symbol;
      this.pageSize = this.bisTrackSettings.searchPageSize;
    });

    this._customerId = this.customerId;
    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.gridModel = this.getGridModel([]);
    });
    // this.gridModel = this.getGridModel();
    // this.getGridData();

    // this._customerId=this.customerId;
    // this.fieldAgentService.getWebTrackUser().subscribe(webTrackRes => {
    //       this.webTrackUser = webTrackRes;
    //       //console.log(this.webTrackUser, 'product purchased grid start');
    //       this.gridModel = this.getGridModel();
    //        this.getGridData();
    // });
    // this.client.apiWebTrackUserAdminUserByLoginNameByWebTrackInstanceIdGet(this.config.getLoggedinUserName(), this.config.getwebTrackInstanceID()).subscribe(webTrackRes => {
    //     this.webTrackUser = webTrackRes;
    //     this.gridModel = this.getGridModel();
    //     this.getGridData();
    //   });
  }


  getGridModel(purchasedList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: purchasedList,
      columns: [
        { field: 'productCode', title: 'PRODUCT CODE', width: 60, hidden: false },
        { field: 'productDescription', title: 'PRODUCT DESCRIPTION', width: 60, hidden: false },
        { field: 'orderDate', title: 'ORDER DATE', width: 60, hidden: false, cellTemplate: this.dateTemplate },
        { field: 'orderNumber', title: 'ORDER NUMBER', width: 80, hidden: false },
        { field: 'orderStatus', title: 'STATUS', width: 100, hidden: false },
        { field: 'jobReference', title: 'JOB REF', width: 100, hidden: false },
        { field: 'quantity', title: 'QUANTITY', width: 60, hidden: false, cellTemplate: this.quantityTemplate },
        { field: 'price', title: 'SELL PRICE', width: 60, hidden: false, cellTemplate: this.sellPriceTemplate },
        { field: 'total', title: 'TOTAL PRICE', width: 60, hidden: false, cellTemplate: this.totalPriceTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToProductDetailsView(eventArg.event.dataItem);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToProductDetailsView(args.dataItem);
      //   }
      // },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, purchasedList, false);
        return observerResult;
      }
    };
    return model;
  }

  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, purchasedList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.purchasedProductsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        if (!isMobile) {
          epGrid.model.loadingIndicator = true;
        }
        this.customerProductRequest = new GetProductPurchasesRequest();
        this.customerProductRequest.currentUser = this.webTrackUser;
        this.customerProductRequest.currentUser.customer.customerId = this.customerId;

        this.paging = new PagingParameters();
        this.paging.index = state.skip;
        this.paging.count = this.pageSize;
        this.customerProductRequest.pagingParameters = this.paging;

        this.sort = new SortParameters();
        this.sort.sortColumn = this.sortService.customerProductsPurchasedSortValue; // 'productCode';
        this.sort.direction = this.sortService.customerProductsPurchasedDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        this.customerProductRequest.sortParameters = this.sort;

        // filter parms
        const customerProductPurchaseSearchParameter = new CustomerProductPurchaseSearchParameters();
        customerProductPurchaseSearchParameter.branch = new Branch();
        customerProductPurchaseSearchParameter.branch.branchID = this.filterService.selectedPurchasedBranchId;
        customerProductPurchaseSearchParameter.productSearchString = this.searchString == undefined ? this.filterService.purchasedProductSearch : this.searchString;
        customerProductPurchaseSearchParameter.jobRefSearchString = this.filterService.purchasedJobrefSearch ? this.filterService.purchasedJobrefSearch : '';
        this.filterService.purchasedProductSearch = this.searchString == undefined ? this.filterService.purchasedProductSearch : this.searchString;
        if (this.filterService.selectedPurchasedDateOptionId != CustomerProductPurchaseSearchDateRange.Custom) {
          this.SetAutomaticDateRange(customerProductPurchaseSearchParameter);
        } else {
          customerProductPurchaseSearchParameter.startDate = this.filterService.purchasedProductStartDate;
          customerProductPurchaseSearchParameter.endDate = this.filterService.purchasedProductEndDate;
          customerProductPurchaseSearchParameter.startDate = customerProductPurchaseSearchParameter.startDate ? this.getLocalTime(customerProductPurchaseSearchParameter.startDate) : this.filterService.purchasedProductStartDate;
          customerProductPurchaseSearchParameter.endDate = customerProductPurchaseSearchParameter.endDate ? this.getLocalTime(customerProductPurchaseSearchParameter.endDate) : this.filterService.purchasedProductEndDate;
        }

        this.customerProductRequest.searchParameters = customerProductPurchaseSearchParameter;
        this.client.getProductPurchases(this.customerProductRequest).subscribe(res => {
          purchasedList = res.lines;
          if (purchasedList != null && purchasedList != undefined && purchasedList.length > 0) {
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (purchasedList.length < state.take) {
              this.lastRecords = purchasedList;
            } else {
              this.purchasedProductsCollection = [...this.purchasedProductsCollection, ...purchasedList];
            }
            if (!isMobile) {
              this.mobileData = this.purchasedProductsCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.purchasedProductsCollection.length;
            const result: IEPGridDataResult = {
              data: purchasedList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else {
      return 500; // return 500;
    }
  }


  getGridData() {
    this.purchasedProductsCollection.length = 0;
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  navigateToProductDetailsView(args) {
    const navigationExtras: NavigationExtras = {
      state: args,
      queryParams: {
        'id': this.customerId,
      },
      skipLocationChange: true
    };
    this.router.navigate(['/home/customer/productdetails'], navigationExtras);
  }

  onCardClick(model) {
    this.navigateToProductDetailsView(model);
  }


  SetAutomaticDateRange(searchParameters) {

    switch (this.filterService.selectedPurchasedDateOptionId) {
      case CustomerProductPurchaseSearchDateRange.Last30Days:
        searchParameters.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
        searchParameters.endDate = new Date();
        break;
      case CustomerProductPurchaseSearchDateRange.CurrentMonth:
        searchParameters.startDate = new Date(new Date().setMonth(new Date().getMonth(), 1));
        searchParameters.endDate = new Date();
        break;
      case CustomerProductPurchaseSearchDateRange.Last2Months:
        searchParameters.startDate = new Date(new Date().setMonth(new Date().getMonth() - 2));
        searchParameters.endDate = new Date();
        break;
      case CustomerProductPurchaseSearchDateRange.Last3Months:
        searchParameters.startDate = new Date(new Date().setMonth(new Date().getMonth() - 3));
        searchParameters.endDate = new Date();
        break;
      case CustomerProductPurchaseSearchDateRange.Last6Months:
        searchParameters.startDate = new Date(new Date().setMonth(new Date().getMonth() - 6));
        searchParameters.endDate = new Date();
        break;
      case CustomerProductPurchaseSearchDateRange.Last12Months:
        searchParameters.startDate = new Date(new Date().setMonth(new Date().getMonth() - 12));
        searchParameters.endDate = new Date();
        break;
      default:
        break;
    }

  }

  // getDates() {

  //   var date = new Date(new Date().setDate(new Date().getDate() - 30));
  //   console.log('Date' + date);

  //   var date1 = new Date(new Date().setMonth(new Date().getMonth() - 2));
  //   console.log('2' + date1);

  //   var date1 = new Date(new Date().setMonth(new Date().getMonth() - 3));
  //   console.log('3' + date1);

  //   var date1 = new Date(new Date().setMonth(new Date().getMonth() - 6));
  //   console.log('6' + date1);

  //   var date1 = new Date(new Date().setMonth(new Date().getMonth() - 12));
  //   console.log('12' + date1);

  //   var date1 = new Date(new Date().setMonth(new Date().getMonth(), 1));
  //   date1.setHours(0, 0, 0);
  //   console.log('13' + date1);
  //   console.log(date1.toLocaleString().replace(',', ''));

  // }

  getLocalTime(date) {
    date.setHours(0, 0, 0, 0);
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - (offset * 60 * 1000));
  }
}
